<template>
  <el-dialog
    :visible="show"
    @update:visible="updateVisiable($event)"
    :title="lan.hint"
    width="410px"
    top="30vh"
    :show-close="true"
    :before-close="handleClose"
    class="hint_dialog"
  >
    <div class="wait_hint">
      <!-- {{lan.youLine}} -->
      <span v-if="lang=='ch'" style="color: #f4a100;font-size: 20px;padding: 0 10px">【{{waitData.broadcast_name}}】的面试官邀请您视频面试，30秒内同意可直接进入直播间，超时后将被移出排队队列。</span>
      <span v-if="lang=='en'" style="color: #f4a100;font-size: 20px;padding: 0 10px">【{{waitData.broadcast_name_en}}】your MC will be removed from the queue within 30 seconds!</span>


      <span>{{lan.canEnter1}}</span>
      <span>{{lan.canEnter2}}</span>
      <span>{{lan.canEnter3}}</span>
    </div>
    <div class="wait_btn">
      <el-button
        @click="handleJoin"
        style="width: 120px;height: 40px;background-color: #f4a100;font-size: 14px;border: none;color: #ffffff"
      >{{lan.into}}<span class="wait_time" v-if="timer != null">{{time}}s</span>
      </el-button>
      <el-button
        @click="handleNotJoin"
        style="width: 120px;height: 40px;background-color: #cccccc;font-size: 14px;border: none;color: #ffffff"
      >{{lan.notEnter}}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
  import {getDialogJoin, getNotEnter, notJoinRoom, exit} from "../../api/webSocket";
  import {language} from "../../language/get";
  import {getLiveUrl, getNewLiveUrl, ClearQueue} from "../../api/forum";
  import {MessageBox} from 'element-ui';
  import {mapGetters} from "vuex"
  import {roomUrl, windowsGoTo} from "../../common/url";
  import Cookie from "../../common/cookie";
  export default {
    props: {
      show: {
        type: Boolean,
        default: false
      },
      waitData: {
        type: Object,
        default: () => {}
      },
      nowRoom:{
        type: String,
      }
    },
    computed: {
      ...mapGetters(["token", "userInfo"])
    },
    data() {
      return {
        lan: language(),
        lang: Cookie.get("lang"),
        time: 30,
        timer: null,
        userType: sessionStorage.getItem('userType')
      }
    },
    methods: {
      handleClose(){
        this.show = false;
        // this.ClearQueue();
        this.handleNotJoin();
      },
      updateVisiable(v) {
        this.$emit("update:show", v);
      },
      handleJoin() {
        var _this = this;
        const alterProps = {token: this.token,roomid:this.waitData.roomid,type:1};
        const props ={token: this.token,broadcast_id:this.waitData.roomid};
          getLiveUrl(props).then(res => {
             if (res.type == 11){
                MessageBox({
                  title: "",
                  message: Cookie.get("lang")=='ch'?res.text:res.text_en,
                  confirmButtonText: language().confirm,
                  cancelButtonText: language().cancel,
                  showCancelButton: false,
                  // type: 'success'
                }).then(() => {
                  //确认
                }).catch(() => {
                  //取消
                });
              }else if (res.type != '1') {
              if (this.lang == "ch") {
                this.$message.error({message: res.text, offset: 120})
              }else {
                this.$message.error({message: res.text_en, offset: 120})
              }
              this.updateVisiable(false);
              return;
            }

              const data = res.data[0];
              return (window.location.href = windowsGoTo() + roomUrl(data, _this.userInfo.true_name))
              // return (window.open(windowsGoTo() + roomUrl(data, _this.userInfo.true_name)))
              getDialogJoin(alterProps).then(resp => {
                if (resp.type == 1) {
                  if(this.userType != 3 && this.userType != 4){
                    console.log(_this.nowRoom,'123123123123');
                    var exitData = {
                        token: _this.token,
                        roomid: _this.nowRoom
                    }
                    exit(exitData).then(response =>{
                        this.show = false;
                        sessionStorage.setItem('userType', res.prcurl);
                        let name = Cookie.get("lang") == 'ch' ? (_this.userInfo.true_name || _this.userInfo.true_name_en) : (_this.userInfo.true_name_en || _this.userInfo.true_name);
                        // return (window.open(windowsGoTo() + roomUrl(data, _this.userInfo.true_name)))
                        return window.location.href = windowsGoTo() + roomUrl(data, name)
                    })
                    // _this.send('/Gateway/Live_User_Leave', {
                    //     token: _this.token,
                    //     roomid: _this.nowRoomId
                    // }).then((respon)=>{
                    // });
                  }else{
                        this.show = false;
                        sessionStorage.setItem('userType', res.prcurl);
                        let name = Cookie.get("lang") == 'ch' ? (_this.userInfo.true_name || _this.userInfo.true_name_en) : (_this.userInfo.true_name_en || _this.userInfo.true_name);
                        // return (window.open(windowsGoTo() + roomUrl(data, _this.userInfo.true_name)))
                        return window.location.href = windowsGoTo() + roomUrl(data, name)
                  }
                }
              })
            // }

          })
      },
      handleNotJoin() {
         const props ={token: this.token,roomid:this.waitData.roomid,user: this.userInfo.user};
         notJoinRoom(props).then(() => {
          this.updateVisiable(false);
          //this.ClearQueue();
         });
        // clearInterval(this.timer);
        // this.time = 30;
        // this.timer = null;
        // this.updateVisiable(false);
      },

      ClearQueue(){


        // const props ={token: this.token,roomid:this.waitData.roomid,type:2};
        // // getNotEnter(props).then(() => {});
        // clearInterval(this.timer);
        // getNotEnter(props).then(() => {});
        // this.updateVisiable(false);
        // this.time = 30;
        // this.timer = null;
        // return
        // console.log(this.userInfo);
        // return;
        const params = {
          roomid: this.waitData.roomid,
        }
        ClearQueue(params).then(()=>{
          this.updateVisiable(false);
          this.time = 30;
          this.timer = null;
        })
      }
    },
    watch: {
      show: {
        handler() {
          if (this.show == true) {
            clearInterval(this.timer);
            this.time = 30;
            this.timer = null;
            const props ={token: this.token,roomid:this.waitData.roomid,type:2};
            if (!this.timer){
              this.timer = setInterval(() => {
                if (this.time == 0) {
                  clearInterval(this.timer);
                  // getNotEnter(props).then(() => {});
                  this.ClearQueue();
                  this.updateVisiable(false);
                  this.time = 30;
                  this.timer = null;
                  //this.handleNotJoin();

                }
                this.time--;
              },1000)
            }
          }
          if (this.show == false) {
            clearInterval(this.timer)
            this.time = 30;
            this.timer = null;
            this.updateVisiable(false);
          }
        },
        immediate: true,
        deep: true
      }
    }
  }
</script>

<style scoped>
  .wait_hint {
    text-align: center;
    color: #424242;
    font-size: 18px;
    margin-top: 35px;
  }
  .wait_btn {
    text-align: center;
    margin-top: 40px;
  }
  .el-button+.el-button {
    margin-left: 40px !important;
  }
  .el-message-box__title {
    padding-bottom: 10px !important;
    border-bottom: 1px solid #a1a1a1 !important;
  }
  .wait_time{
    color: #eb0d0d;
    font-size: 14px;
  }
</style>
